import { Linked } from "@type-r/models";
import { asDateTime, Flex } from "lqx-react";
import React from "react";
import { UserEntitlementCatalogs } from "src/app/models/UserEntitlements";
import { Can } from "src/app/services/can";
import { Connection } from "../api/connection";
import { AssetTypeName, Body, colorStyles, Container, Footer, FooterContent, FooterLabel, FooterRow, NameBlock, NameLabel, PolicyCardDate, Row, State } from "../components/item-card-styles";
import { ConnectionsActions } from "./connections-actions";

export const ConnectionsCardRenderer = ($activeCard: Linked<Connection>, $selectedTab: Linked<string>) =>
    ({ data, style, index }) => {
        const classes = colorStyles();
        const connection: Connection = data.items[index];
        const isActive = Boolean($activeCard.value) && connection.id === $activeCard.value.id;

        const connectionStatus = (connection: Connection) => connection && connection.isActive ? <span className={classes.active}>Active</span> : <span className={classes.inactive}>Inactive</span>

        return (
            <Row style={style}>
                <Flex row grow>
                    <Container {...{ active: isActive ? 'true' : 'false' }} {...{ onClick: () => { $activeCard.set(connection); $selectedTab.set('details') } }}>
                        <Body>
                            <Flex row>
                                <Flex column grow>
                                    <NameBlock>
                                        <State>{connectionStatus(connection)}</State>
                                        <AssetTypeName> {connection.name}</AssetTypeName>
                                    </NameBlock>
                                    <Flex row>
                                        <PolicyCardDate>
                                            <NameLabel>
                                                {connection.company ? connection.company.name : ''}
                                            </NameLabel>
                                        </PolicyCardDate>
                                    </Flex>
                                </Flex>
                                {Can(UserEntitlementCatalogs.EditConnectionsPage) && !$activeCard.value &&
                                    <ConnectionsActions connection={connection} />
                                }
                            </Flex>
                        </Body>
                        <Footer>
                            <Flex column>
                                <FooterRow>
                                    <FooterLabel>Flow Direction: </FooterLabel> <FooterContent>{connection.flowType.name}</FooterContent>
                                    <FooterLabel>Channel: </FooterLabel> <FooterContent>{connection.channelType.name}</FooterContent>
                                </FooterRow>
                            </Flex>
                            <Flex column grow>
                                <FooterRow style={{ justifyContent: 'flex-end' }}>
                                    <FooterLabel>Created On: </FooterLabel> <FooterContent>{asDateTime(connection.createdOn)}</FooterContent>
                                    <FooterLabel>Connection ID: </FooterLabel> <FooterContent>{connection.id}</FooterContent>
                                </FooterRow>
                            </Flex>
                        </Footer>
                    </Container>
                </Flex>
            </Row>
        )
    }
